// extracted by mini-css-extract-plugin
module.exports = {"orangeBtn":"IHaeb","simple":"IHaed","big":"IHct"};